import React from 'react'
import axios from 'axios'
import { Modal, message } from 'antd'

const DeleteColumn = (props) => {
  const merchantOid = localStorage.getItem('merchant_oid')
  const { oid, name } = props.data

  const handleOk = () => {
    axios.post('/p/content/column/delete', { 
      merchant_oid: merchantOid, 
      column_oid: oid 
    })
      .then(function (response) {
        if (response.errcode === 0) {
          message.success('删除栏目成功！')
          props.isCancel()
          props.getColumnList()
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  return (
    <Modal 
      title="删除栏目"
      open={props.isOpen}
      onOk={handleOk}
      onCancel={props.isCancel}
      cancelText="取消"
      okType='danger'
      okText='删除'>

      <p>正在将栏目
        <span style={{color: '#005dff'}}>《{name}》</span>
        从列表中移除，此操作不可逆，是否确认删除？
      </p>
    </Modal>
  )
}

export default DeleteColumn
